import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'katex/dist/katex.min.css'; // KaTeX styles for LaTeX rendering
import App from './App';
import { AuthProvider, useAuth } from './AuthContext';
import LandingPage from './LandingPage';
import AdminPanel from './AdminPanel';

function AppWithAuth() {
  const { isAuthenticated, loading, user, logout, isAdmin, login, register } = useAuth();
  const [showAdminPanel, setShowAdminPanel] = useState(false);
  const [authError, setAuthError] = useState('');

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    const handleLogin = async (username, password) => {
      try {
        setAuthError('');
        await login(username, password);
      } catch (error) {
        setAuthError(error.message);
        alert(error.message);
      }
    };

    const handleRegister = async (username, email, password) => {
      try {
        setAuthError('');
        await register(username, email, password);
      } catch (error) {
        setAuthError(error.message);
        alert(error.message);
      }
    };

    return <LandingPage onLogin={handleLogin} onRegister={handleRegister} />;
  }

  return (
    <div>
      <div style={{
        position: 'absolute',
        top: '10px',
        right: '10px',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        background: 'rgba(255,255,255,0.9)',
        padding: '8px 15px',
        borderRadius: '20px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <span style={{ fontSize: '14px', color: '#666' }}>
          {user?.username}
          {isAdmin && <span style={{
            marginLeft: '6px',
            padding: '2px 6px',
            background: 'var(--accent-primary)',
            color: 'white',
            borderRadius: '10px',
            fontSize: '11px',
            fontWeight: '600'
          }}>Admin</span>}
        </span>
        {isAdmin && (
          <button
            onClick={() => setShowAdminPanel(true)}
            style={{
              padding: '6px 12px',
              background: 'var(--accent-primary)',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '13px'
            }}
          >
            Admin Panel
          </button>
        )}
        <button
          onClick={logout}
          style={{
            padding: '6px 12px',
            background: 'var(--accent-primary)',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '13px'
          }}
        >
          Logout
        </button>
      </div>
      <App />
      {showAdminPanel && <AdminPanel onClose={() => setShowAdminPanel(false)} />}
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AppWithAuth />
    </AuthProvider>
  </React.StrictMode>
);
